import { ApolloError, useQuery } from '@apollo/client'
import { OBJECTIVES_IN_MEETING } from './ObjectiveQuery'
import { ObjectivesInMeetingQuery, ObjectivesInMeetingQueryVariables } from '../../types'

export default (
  meetingId: string,
): {
  data: ObjectivesInMeetingQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<ObjectivesInMeetingQuery, ObjectivesInMeetingQueryVariables>(OBJECTIVES_IN_MEETING, {
    variables: {
      meetingId: meetingId,
    },
    fetchPolicy: 'network-only',
  })

  return { data, error, loading }
}
